import Modal from "react-modal";
import { addLogistics, addTransport } from "../services/btc-api.service";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router";

const Logistic = ({ user }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    if (subtitle) subtitle.style.color = "#f00";
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      height: "auto",
      overflowY: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "auto",
      padding: "0 2%",
      boxShadow:
        "0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05), 0 100px 80px rgba(0, 0, 0, 0.07)",
      borderRadius: 6,
      backgroundColor: "#f2f2f2",
    },
  };

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [isLogistic, setIsLogistic] = React.useState(true);
  const [logisticDetails, setLogisticDetails] = React.useState({
    from: "",
    to: "",
    name: "",
    country: "",
    email: "",
    selectedOption: "roro",
    contactNumber: "",
    vehicleCondition: "Drivable",
  });

  const handleChange = (e) => {
    setLogisticDetails({
      ...logisticDetails,
      [e.target.name]: e.target.value,
    });
  };

  let subtitle;

  const openModal = (from) => {
    setIsOpen(true);
    setIsLogistic(from === "logistic");
  };

  const closeModal = () => {
    setIsOpen(false);
    setLogisticDetails({
      from: "",
      to: "",
      name: "",
      country: "",
      email: "",
      selectedOption: "roro",
      contactNumber: "",
      vehicleCondition: "Drivable",
    });
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={() => closeModal()}
        ariaHideApp={false}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="logistics_div">
          <h2
            style={{ color: "#0944c2", textAlign: "center", paddingBottom: 20 }}
          >
            {isLogistic ? "Logistic" : "Transport"} details
          </h2>
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              const body = {
                from: logisticDetails.from,
                to: logisticDetails.to,
              };

              if (isLogistic) {
                body["selectedOption"] = logisticDetails.selectedOption;
              }

              if (user && user._id) {
                body["userId"] = user._id;
              } else {
                body["name"] = logisticDetails.name;
                body["country"] = logisticDetails.country;
                body["email"] = logisticDetails.email;
                body["contactNumber"] = logisticDetails.contactNumber;
              }

              body["vehicleCondition"] = logisticDetails.vehicleCondition;

              if (isLogistic) {
                await addLogistics(body);
                closeModal();
              } else {
                await addTransport(body);
                closeModal();
              }
            }}
          >
            <div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <input
                  required
                  type="text"
                  name="from"
                  placeholder="From port"
                  onChange={(e) => handleChange(e)}
                />
                <input
                  required
                  style={{ marginLeft: "10px" }}
                  type="text"
                  name="to"
                  placeholder="To port"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              {user === null && (
                <div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <input
                      required
                      type="text"
                      name="name"
                      placeholder="Name"
                      onChange={(e) => handleChange(e)}
                    />
                    <input
                      required
                      style={{ marginLeft: "10px" }}
                      type="text"
                      name="country"
                      placeholder="Country"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <input
                    required
                    type="email"
                    name="email"
                    placeholder="Email"
                    onChange={(e) => handleChange(e)}
                  />
                  <input
                    required
                    type="text"
                    name="contactNumber"
                    placeholder="Contact number"
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              )}
              {isLogistic && (
                <div
                  style={{ display: "flex", flexDirection: "row", padding: 5 }}
                >
                  <input
                    type="radio"
                    onClick={() =>
                      setLogisticDetails({
                        ...logisticDetails,
                        selectedOption: "roro",
                      })
                    }
                    readOnly={true}
                    checked={
                      logisticDetails.selectedOption === ""
                        ? true
                        : logisticDetails.selectedOption === "roro"
                          ? true
                          : false
                    }
                    name="selectedOption"
                    value="roro"
                    style={{ marginRight: 10 }}
                  />{" "}
                  Roro
                  <input
                    type="radio"
                    onClick={() =>
                      setLogisticDetails({
                        ...logisticDetails,
                        selectedOption: "couriers",
                      })
                    }
                    readOnly={true}
                    checked={logisticDetails.selectedOption === "couriers"}
                    name="selectedOption"
                    value="couriers"
                    style={{ marginLeft: 50, marginRight: 10 }}
                  />{" "}
                  Container
                </div>
              )}

              <div
                style={{ display: "flex", flexDirection: "row", padding: 5 }}
              >
                <input
                  type="radio"
                  onClick={() =>
                    setLogisticDetails({
                      ...logisticDetails,
                      vehicleCondition: "Drivable",
                    })
                  }
                  checked={
                    logisticDetails.vehicleCondition === ""
                      ? true
                      : logisticDetails.vehicleCondition === "Drivable"
                        ? true
                        : false
                  }
                  name="vehicleCondition"
                  value="Drivable"
                  style={{ marginRight: 10 }}
                  readOnly={true}
                />
                Drivable
                <input
                  type="radio"
                  onClick={() =>
                    setLogisticDetails({
                      ...logisticDetails,
                      vehicleCondition: "Non-Drivable",
                    })
                  }
                  readOnly={true}
                  checked={logisticDetails.vehicleCondition === "Non-Drivable"}
                  name="vehicleCondition"
                  value="Non-Drivable"
                  style={{ marginLeft: 24, marginRight: 10 }}
                />{" "}
                Non-Driveable
              </div>
            </div>
            <div
              style={{ display: "flex", justifyContent: "center", padding: 30 }}
            >
              <input type="submit" value="Submit" className="submit_logistic" />
            </div>
          </form>
        </div>
      </Modal>
      {isMobile && (
        <div className="logistic-new-images">
          <img
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/logistics")}
            src="logistic.png"
            alt="logistic"
          />
          <img
            onClick={() => navigate("/transport")}
            style={{ marginTop: 10, cursor: "pointer" }}
            src="transport-service.png"
            alt="logistic"
          />
        </div>
      )}
      {!isMobile && (
        <div className="logistic">
          <div className="l1">
            <div className="img left-margin-wrapper1">
              <img className="elipse" src="elipse5.png" alt="elipse5.png" />
              <img className="vehicle" src="ship.png" alt="ship.png" />
            </div>
            <div className="text">

              <h2>
                BTC TRANSPORT
                <br /> SERVICE
              </h2>
              <span>
                Discover Thousands <br />
                of Vehicles & Heavy Equipment <br />
                at a Fraction of the Price.
              </span>
              <button
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/logistics")}
              >
                VIEW MORE
              </button>
            </div>
          </div>
          <div className="l1 green-gradient">
            <div className="img left-margin-wrapper1">
              <img className="elipse" src="elipse5.png" alt="elipse5.png" />
              <img className="vehicle" src="elipse8.png" alt="truck.png" />
            </div>
            <div className="text">
              <h1>BTC LOGISTIC</h1>
              <span>
                Discover Thousands <br />
                of Vehicles & Heavy Equipment <br />
                at a Fraction of the Price.
              </span>
              <button
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/transport")}
              >
                VIEW MORE
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Logistic;
